import { render, staticRenderFns } from "./detail-treatment.vue?vue&type=template&id=412bba8f"
import script from "./detail-treatment.vue?vue&type=script&lang=js"
export * from "./detail-treatment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports